import { STATUS_STYLE } from "@/lib/engagements";

export const StatusBadge = ({ status, testid }) => (
  <span
    data-testid={testid}
    className={`inline-flex items-center border px-2 py-0.5 text-xs font-medium whitespace-nowrap rounded-sm ${
      STATUS_STYLE[status] || STATUS_STYLE["Haven't start"]
    }`}
  >
    {status}
  </span>
);
